import { render, staticRenderFns } from "./reward-detail.vue?vue&type=template&id=6defe3a1"
import script from "./reward-detail.vue?vue&type=script&lang=js"
export * from "./reward-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports